import { render } from "./TheFirstProductList.vue?vue&type=template&id=28ba9440&scoped=true&lang=pug&bindings={}"
import script from "./TheFirstProductList.vue?vue&type=script&lang=js"
export * from "./TheFirstProductList.vue?vue&type=script&lang=js"

import "./TheFirstProductList.vue?vue&type=style&index=0&id=28ba9440&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-28ba9440"

export default script